import { css } from '@emotion/css';
import { theme } from 'antd';
export var useEmotionCss = function useEmotionCss(cssFn) {
  var token = theme.useToken();
  return css(cssFn(token));
};